import React, { useState } from "react";
import { SettingsContext } from "~/Context/SettingsContext";

const LOCAL_STORE_HOME_TRACK_LAYOUT = "chim_track_cols";
const LOCAL_STORE_PLAYER_JUKEBOX = "chim_player_jukebox";
const LOCAL_STORE_PLAYER_JUKEBOX_AUTOPLAY = "chim_player_jukebox_autoplay";

const SettingsProvider = (props) => {
  const [settings, updateSettings] = useState({
    trackUiCols: localStorage.getItem(LOCAL_STORE_HOME_TRACK_LAYOUT) === "true" || false,
    playInJukebox: localStorage.getItem(LOCAL_STORE_PLAYER_JUKEBOX) === "true" || false,
    autoplayInJukebox: localStorage.getItem(LOCAL_STORE_PLAYER_JUKEBOX_AUTOPLAY) === "true" || false,
  });

  const toggleLayout = () => {
    const updatedSettings = Object.assign({}, settings, {
      trackUiCols: !settings.trackUiCols,
    });
    localStorage.setItem(LOCAL_STORE_HOME_TRACK_LAYOUT, updatedSettings.trackUiCols);
    updateSettings(updatedSettings);
  };

  const toggleJukebox = () => {
    const updatedSettings = Object.assign({}, settings, {
      playInJukebox: !settings.playInJukebox,
    });
    localStorage.setItem(LOCAL_STORE_PLAYER_JUKEBOX, updatedSettings.playInJukebox);
    updateSettings(updatedSettings);
  };

  const toggleJukeboxAutoPlay = () => {
    const updatedSettings = Object.assign({}, settings, {
      autoplayInJukebox: !settings.autoplayInJukebox,
    });
    localStorage.setItem(LOCAL_STORE_PLAYER_JUKEBOX_AUTOPLAY, updatedSettings.autoplayInJukebox);
    updateSettings(updatedSettings);
  };

  return (
    <SettingsContext.Provider
      value={{
        settings: settings,
        toggleLayout: toggleLayout,
        toggleJukebox: toggleJukebox,
        toggleJukeboxAutoPlay: toggleJukeboxAutoPlay,
      }}
    >
      {props.children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
